/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import { useSelector } from 'react-redux';

import { Button, LinkBlock } from '../../../../../../components/common';
import { makeSelectTranslationCommon } from '../../../../../../modules/internationalization/intSelectors';
import Modal from '../../../../../../modules/modal/components/Modal';
import { useModalOpenError } from '../../../../../../modules/modal/hooks/useModalOpenError';
import { useModalOpenSuccess } from '../../../../../../modules/modal/hooks/useModalOpenSuccess';
import { EModalStatus } from '../../../../../../modules/modal/types/modalTypes';
import { personalDataTranslationSelector } from '../../selectors';
import { useSavePersonalDataMutation } from '../../store';
import { IPersonalDataInfoEdit } from '../../types/info-edit';


interface ISubscriberIdPersonalDataEditConfirmModal {
    subscriberId: string;
    excludeFiles: string[];
    personalData: IPersonalDataInfoEdit;
    message: string;
    onCancel: () => void;
    onCloseModal: () => void;
    onConfirm: () => void;
    onSuccess: () => void;
}

const PersonalDataEditConfirmModal = ({
                                          subscriberId,
                                          personalData,
                                          excludeFiles,
                                          message,
                                          onCancel,
                                          onConfirm,
                                          onSuccess,
                                          onCloseModal,
                                      }: ISubscriberIdPersonalDataEditConfirmModal) => {

    const [save] = useSavePersonalDataMutation();

    const { open: openModalSuccess } = useModalOpenSuccess();
    const { open: openModalError } = useModalOpenError();

    const tabTranslation = useSelector(personalDataTranslationSelector());
    const translationCommon = useSelector(makeSelectTranslationCommon());

    const onConfirmHandler = () => {
        save({ personalData, subscriberId, excludeFiles, withoutConfirm: true })
            .then(() => {
                onCloseModal();
                openModalSuccess(tabTranslation.personalDataEdit.modal[EModalStatus.success].saveData, onSuccess);
            })
            .catch(() => {
                onCloseModal();
                openModalError(tabTranslation.personalDataEdit.modal[EModalStatus.failure].saveData);
            });
        onConfirm();
    };

    return (
        <Modal dataName="modal-error" width="380px">
            <Modal.Title>
                {tabTranslation.personalDataEdit.modal[EModalStatus.start].saveData}
            </Modal.Title>
            {message}
            <Modal.Control>
                <Button kind="medium" onClick={onConfirmHandler}>{translationCommon.modal.continue}</Button>
                <LinkBlock onClick={onCancel}>{translationCommon.modal.cancel}</LinkBlock>
            </Modal.Control>
        </Modal>
    );
};

export default PersonalDataEditConfirmModal;
